module.exports = __webpack_public_path__ + "img/whiskey-glass.9136f4b7.svg";